import { render, staticRenderFns } from "./DashboardNewMembers.vue?vue&type=template&id=125f89fa&scoped=true"
import script from "./DashboardNewMembers.vue?vue&type=script&lang=ts"
export * from "./DashboardNewMembers.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNewMembers.vue?vue&type=style&index=0&id=125f89fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f89fa",
  null
  
)

export default component.exports